import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/awesome-design-system-2/awesome-design-system-2/node_modules/@bridgetool/gatsby-theme-dev/src/components/ThemeComponents/layout.js";
import { Caption } from '@bridgetool/gatsby-theme-dev';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const DoDontContainer = makeShortcode("DoDontContainer");
const Do = makeShortcode("Do");
const Dont = makeShortcode("Dont");
const ButtonDanger = makeShortcode("ButtonDanger");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Header 1`}</h1>
    <h2>{`Header 2`}</h2>
    <h3>{`Haeder 3`}</h3>
    <h4>{`Header 4`}</h4>
    <h5>{`Header 5`}</h5>
    <h6>{`Header 6`}</h6>
    <h2>{`Lists`}</h2>
    <ul>
      <li parentName="ul">{`Unordered 1`}</li>
      <li parentName="ul">{`Unordered 2`}</li>
      <li parentName="ul">{`Unordered 3`}</li>
    </ul>
    <ol>
      <li parentName="ol">{`Ordered 1`}</li>
      <li parentName="ol">{`Ordered 2`}</li>
      <li parentName="ol">{`Ordered 3`}</li>
    </ol>
    <ul>
      <li parentName="ul">{`Nested 1`}
        <ul parentName="li">
          <li parentName="ul">{`Nested 1.1`}</li>
          <li parentName="ul">{`Nested 1.2`}</li>
        </ul>
      </li>
      <li parentName="ul">{`Nested 2`}</li>
    </ul>
    <dl>
  <dt>Definition list 1</dt>
  <dd>Description of item 1</dd>
  <dt>Definition list 2</dt>
  <dd>Description of item 2</dd>
    </dl>
    <h2>{`Horizontal Separator`}</h2>
    <hr />
    <h2>{`Quote`}</h2>
    <blockquote>
      <p parentName="blockquote">{`More on semantic markup:`}</p>
      <ul parentName="blockquote">
        <li parentName="ul"><a parentName="li" {...{
            "href": "http://webaim.org/techniques/semanticstructure/"
          }}>{`Semantic Structure – WebAIM`}</a></li>
      </ul>
    </blockquote>
    <h2>{`Table`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`alt`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Passed through to alt on img tag`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`size`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Number`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`20`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`adds the `}<inlineCode parentName="td">{`avatar-small`}</inlineCode>{` class if less than 24`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`src`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The source url of the avatar image`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`square`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Boolean`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`false`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Used to create a square avatar`}</td>
        </tr>
      </tbody>
    </table>
    <h2>{`Code block`}</h2>
    <h3>{`Html code`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<input type="checkbox" value="1" checked />
`}</code></pre>
    <p>{`To provide the code blocks use the following markdown syntax. You can specify the language
for proper highlighting.`}</p>
    <code>
      {`
${'```'}html
<input type="checkbox" value="1" checked>
${'```'}
`}
    </code>
    <h3>{`Live example`}</h3>
    <p>{`The code in the examples can be rendered so that they can be living!`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html",
        "metastring": "live",
        "live": true
      }}>{`<input type="checkbox" value="1" checked /> Label
`}</code></pre>
    <p>{`Merely add `}<inlineCode parentName="p">{`live`}</inlineCode>{` attribute next to the language.`}</p>
    <code>
      {`
${'```'}html live
<input type="checkbox" value="1" checked> Label
${'```'}
`}
    </code>
    <h3>{`Example without code`}</h3>
    <p>{`Or you can provide a living example of the component but hide its code.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html",
        "metastring": "live nocode",
        "live": true,
        "nocode": true
      }}>{`<input type="checkbox" value="1" checked /> Label
`}</code></pre>
    <p>{`This is done with an additional `}<inlineCode parentName="p">{`nocode`}</inlineCode>{` attribute.`}</p>
    <code>
      {`
${'```'}html live nocode
<input type="checkbox" value="1" checked> Label
${'```'}
`}
    </code>
    <h3>{`React live examples`}</h3>
    <p>{`Live examples work also with the linked React components. You can give a code
example and render its preview.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<AwesomeButton type="primary">Primary</AwesomeButton>
`}</code></pre>
    <code>
      {`
${'```'}jsx live
<AwesomeButton type="primary">Primary</AwesomeButton>
${'```'}
`}
    </code>
    <p>{`Or you can choose to hide the code block leaving only the preview.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live nocode",
        "live": true,
        "nocode": true
      }}>{`<AwesomeButton type="primary">Primary</AwesomeButton>
`}</code></pre>
    <code>
      {`
${'```'}jsx live nocode
<AwesomeButton type="primary">Primary</AwesomeButton>
${'```'}
`}
    </code>
    <p>{`And the code blocks alone work for React examples as well.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<AwesomeButton type="primary">Primary</AwesomeButton>
`}</code></pre>
    <code>
      {`
${'```'}jsx
<AwesomeButton type="primary">Primary</AwesomeButton>
${'```'}
`}
    </code>
    <h2>{`Special blocks`}</h2>
    <h3>{`Do and don't`}</h3>
    <h4>{`With images`}</h4>
    <DoDontContainer mdxType="DoDontContainer">
  <Do src="https://user-images.githubusercontent.com/586552/63106528-06de5100-bf51-11e9-8a5e-98583ed74874.png" mdxType="Do">
    Use brief and direct communication
  </Do>
  <Dont src="https://user-images.githubusercontent.com/586552/63106527-06de5100-bf51-11e9-858c-72de6a5c728a.png" mdxType="Dont">
    Don't use wordy and redundant copy
  </Dont>
    </DoDontContainer>
    <h4>{`With HTML`}</h4>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    Use brief and <b>direct communication</b>
  </Do>
  <Dont mdxType="Dont">
    Don't use wordy and redundant copy
  </Dont>
    </DoDontContainer>
    <h4>{`With makrdown (TODO)`}</h4>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    Use brief and direct communication **test**
  </Do>
  <Dont mdxType="Dont">
    Don't use wordy and redundant copy
  </Dont>
    </DoDontContainer>
    <h3>{`Caption`}</h3>

    <img alt="" src="https://s3.us-west-2.amazonaws.com/photos.puppyspot.com/breeds/245/card/500000291_medium.jpg" />
    <Caption mdxType="Caption">A beautiful husky puppy.</Caption>
    <h2>{`React components from a global scope`}</h2>
    <ButtonDanger mdxType="ButtonDanger">Button Danger</ButtonDanger>
    <h2>{`Live React`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Button>Button</Button>
<ButtonDanger>Button Danger</ButtonDanger>
<ButtonOutline>Button Outline</ButtonOutline>
<ButtonPrimary>Button Primary</ButtonPrimary>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      